@if (isFetching) {
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
}

@if (error) {
  <div class="alert alert-danger">
    <div class="row">
      <h4>Error loading data: {{error}}</h4>
    </div>
  </div>
}

@if (overviewData) {
  <h2 class="title">Overview</h2>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h4>Allele Overview</h4>
          <p>Number of alleles in the selected species and gene.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="info-boxes">
        <div class="info-box">
          <div class="box-content">
            <span id="total-alleles" class="big">{{ overviewData.total }}</span>
            <span class="title">Number of Alleles</span>
          </div>
        </div>
        <div class="info-box">
          <div class="box-content">
            <span id="alleles-baseline" class="big">{{ overviewData.baseline }}</span>
            <span class="title">Alleles in Baseline</span>
          </div>
        </div>
        <div class="info-box">
          <div class="box-content">
            <span id="novel-alleles" class="big">{{ overviewData.novel }}</span>
            <span class="title">Novel Alleles</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="chart-container">
        <canvas
          baseChart
          [data]="chartData"
          [options]="chartOptions"
          [type]="chartType"
        >
        </canvas>
      </div>
    </div>
  </div>
}
